import { render, staticRenderFns } from "./allocationUserStorehouseManageList.vue?vue&type=template&id=9754acba&scoped=true"
import script from "./allocationUserStorehouseManageList.vue?vue&type=script&lang=js"
export * from "./allocationUserStorehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./allocationUserStorehouseManageList.vue?vue&type=style&index=0&id=9754acba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9754acba",
  null
  
)

export default component.exports